import Chip from '@mui/material/Chip';
import { Box } from '@/component/Box';
import { useTranslation } from '@/feature/lang';

interface ChipsProps {
  names?: (string | undefined | null)[];
  max?: number;
  ml?: number;
}

export default function EquipmentChips({
  names = [],
  max = 4,
  ml = 0,
}: ChipsProps) {
  const { translate, texts } = useTranslation();
  const chipNames = names.filter((name) => !!name);
  const chips =
    chipNames.length > max
      ? [
          ...chipNames.slice(0, max - 1),
          translate(texts.fleet.multiSelection.moreChip, {
            count: chipNames.length - max + 1,
          }),
        ]
      : chipNames;

  if (!chips) {
    return null;
  }

  return (
    <Box sx={{ ml }}>
      {chips.map((chip, i) => (
        <Chip
          key={`eq-chip-${i}`}
          size="small"
          variant="filled"
          label={chip}
          color="secondary"
          sx={{ mx: 0.5 }}
        />
      ))}
    </Box>
  );
}
